import { useEffect, useRef, useState, type Dispatch, type SetStateAction, type default as React } from 'react';

import AnnouncementIcon from '@mui/icons-material/Announcement';
import { Grid, Box } from '@mui/material'
import { useAuthContext } from 'AuthProvider'
import { SearchButton, SelectCenter, SelectItem, SelectTypeCode } from 'components/commonparts'

import type { GetMstCenterStockItemCenterStockItemGetRequest } from 'api-client'

interface SearchConditionProps {
  searchParam: GetMstCenterStockItemCenterStockItemGetRequest
  onSearch: (requestParam: GetMstCenterStockItemCenterStockItemGetRequest) => void
  hasDataEdited: boolean  // 編集中のデータがあるか？
  setDiscardChangeDialogOpen: Dispatch<SetStateAction<boolean>>,
  searchTrigger?: boolean // 親コンポーネントから検索実行された場合に値が変化する
  isAlert?: boolean | null
  onAlertClick?: () => void
}

function SearchCondition({
  searchParam, 
  onSearch, 
  hasDataEdited=false,
  setDiscardChangeDialogOpen,
  searchTrigger,
  isAlert = null,
  onAlertClick,
}: SearchConditionProps) {
  const { loginUserInfo } = useAuthContext()

  const [centerId, setCenterId] = useState<number | null | undefined>(searchParam.centerId)
  const [orgItemCode, setOrgItemCode] = useState<string | null | undefined>(searchParam.orgItemCode)
  const [searchTargetEnabled, setSearchTargetEnabled] = useState(searchParam.searchTargetEnabled)

  const onSearchClick=()=>{
    if (hasDataEdited) {
      setDiscardChangeDialogOpen((prev) => !prev)
      return
    }

    onSearch({
      companyId: loginUserInfo!.companyId,
      centerId,
      orgItemCode,
      searchTargetEnabled,
      enabled: false,
    })  
  }

  const isFirstSearchTriggerEffect = useRef(true)
  useEffect(() => {
    // 初回マウントで親の初期 fetch と二重に /center-stock-item が呼ばれるのを防ぐ
    if (isFirstSearchTriggerEffect.current) {
      isFirstSearchTriggerEffect.current = false
      return
    }
    // searchTriggerの変更を検知して、検索イベントを起こす
    // 親コンポーネントなどで検索を行いたい場合は、このトリガーを使用する
    onSearch({
      companyId: loginUserInfo!.companyId,
      centerId,
      orgItemCode,
      searchTargetEnabled,
      enabled: false,
    })
  }, [searchTrigger])

  return (
        <Grid container>
            <Grid container justifyContent="center" alignItems="center" marginRight='10px'>
              <SelectTypeCode
                  typeGroup="SearchTargetEnabled"
                  typeCode={searchTargetEnabled}
                  setTypeCode={
                    setSearchTargetEnabled as Dispatch<SetStateAction<string | null | undefined>>
                  }
                  setTypeCodeInfo={() => {}}
                  isRequired
                />
            </Grid>
            <SelectCenter
              trCompanyId={searchParam.companyId}
              centerId={centerId}
              setCenterId={setCenterId}
              setCenterInfo={() => {}}
              isRequired={false}
              setIsValid={() => {}}
              enabled={false}
            />
            <SelectItem
              trCompanyId={searchParam.companyId}
              orgItemCode={orgItemCode}
              setOrgItemCode={setOrgItemCode}
              setItemInfo={() => {}}
              isRequred={false}
              setIsValid={() => {}}
              enabled={false}
            />
          <Box display="flex" justifyContent="center" alignItems="end" marginBottom='5px' marginRight='10px'>
              <SearchButton searchId="centerStockItem" onSearchClick={onSearchClick}/>
          </Box>
          {isAlert === true && (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="end"
              marginBottom='5px'
              marginLeft='auto'
              marginRight='4px'
              sx={{ cursor: 'pointer' }}
              onClick={onAlertClick}
            >
              <AnnouncementIcon
                className="action-icon-info has_alert"
                color="inherit"
                fontSize="small"
                sx={{ fontSize: 36 }}
              />
            </Box>
          )}
        </Grid>
  )
}

export default SearchCondition
